// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-css-utilsReact__top--v7lX3{background:green;padding:8px}.src-css-utilsReact__objectProp--mLzVN span:first-child{display:inline-block;width:240px}`, "",{"version":3,"sources":["webpack://./src/css/utilsReact.scss"],"names":[],"mappings":"AAAA,gCACC,gBAAA,CACA,WAAA,CAKC,wDACC,oBAAA,CACA,WAAA","sourcesContent":[".top {\r\n\tbackground: green;\r\n\tpadding: 8px;\r\n}\r\n\r\n.objectProp {\r\n\tspan {\r\n\t\t&:first-child {\r\n\t\t\tdisplay: inline-block;\r\n\t\t\twidth: 240px;\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"top": `src-css-utilsReact__top--v7lX3`,
	"objectProp": `src-css-utilsReact__objectProp--mLzVN`
};
export default ___CSS_LOADER_EXPORT___;
